var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zg-kh-account-withdraw',{attrs:{"acc-center-router-name":"fundAccountHome"},on:{"resultHandler":_vm.resultHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }